import { render, staticRenderFns } from "./Zalandokeywords.vue?vue&type=template&id=2568fa85"
import script from "./Zalandokeywords.vue?vue&type=script&lang=js"
export * from "./Zalandokeywords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports